import React, { useEffect, useState, useMemo, useRef } from 'react';
import { MaskedTextField, TextField } from '@fluentui/react';

import * as DT from 'src/components/base/fields/dateTimeUtils';


const Data = {
  styles: { root: { width: '100%'} },
};


export function TimeField(props) {
  return (
    <DT.WithPicker
      component={TimeFieldBase}
      componentProps={props}
      converterProps={{ formatString: DT.Format.Time, errorString: DT.Errors.Time }}
    />
  );
}


export function TimeFieldBase({ value /* moment */, error, substitution, disabled, onChange }) {
  const [valueString, setValueString] = useState('00:00:00.000');

  useEffect(() => updateStringValue(), []);
  useEffect(() => updateStringValue(), [value, substitution]);

  function updateStringValue() {
    if (!substitution && value.isValid()) {
      const text = DT.momentToString(value, DT.Format.Time);
      setValueString(text);
    }
  }

  function handleOnChange(text) {
    setValueString(text);
    onChange(DT.stringToMoment(text, DT.Format.Time));
  }

  return (
    <>
    { !substitution
      ? (<MaskedTextField
        mask={'99:99:99\.999'}
        suffix={DT.Format.Time}
        value={valueString}
        errorMessage={error}
        styles={Data.styles}
        onChange={(e, text) => handleOnChange(text)}
        disabled={disabled}
      />)
      : (<TextField
        value={substitution}
        errorMessage={error}
        styles={Data.styles}
        onChange={(e, text) => handleOnChange(text)}
        disabled={disabled}
      />)
    }
    </>
  );
}


export default TimeField;